import { NgModule } from "@angular/core"
import { SearchBar } from "./search-bar.component"
import { FormsModule } from "@angular/forms"
import { CommonModule } from "@angular/common"

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [SearchBar],
  exports: [SearchBar]
})
export class SearchBarModule {}
